function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../publisher2/tools/AbstractPublisherTool';
var FeaturedataTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function FeaturedataTool() {
    var _this;
    _classCallCheck(this, FeaturedataTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FeaturedataTool, [].concat(args));
    _this.index = 130;
    _this.group = 'tools';
    _this.bundleName = 'featuredata';
    return _this;
  }

  /**
   * Initialise tool
   * @method init
   */
  _inherits(FeaturedataTool, _AbstractPublisherToo);
  return _createClass(FeaturedataTool, [{
    key: "init",
    value: function init(data) {
      var _data$configuration = data.configuration,
        configuration = _data$configuration === void 0 ? {} : _data$configuration;
      if (configuration[this.bundleName]) {
        this.storePluginConf(configuration[this.bundleName].conf);
        // even if we have the config, we don't want to enable the tool if its not shown
        // if we enable it the plugin won't show and everything looks ok, but getValues() will
        // still return a non-null value which makes featuredata bundle to be
        // started on the embedded map even if it's not used
        this.setEnabled(this.isDisplayed(data));
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return {
        component: null,
        handler: null
      };
    }

    /**
    * Get tool object.
    * @method getTool
    *
    * @returns {Object} tool description
    */
  }, {
    key: "getTool",
    value: function getTool() {
      return {
        id: 'Oskari.mapframework.bundle.featuredata.plugin.FeaturedataPlugin',
        title: Oskari.getMsg('FeatureData', 'publisher.toolLabel'),
        config: this.state.pluginConfig || {}
      };
    }

    /**
    * Get values.
    * @method getValues
    * @public
    *
    * @returns {Object} tool value object
    */
  }, {
    key: "getValues",
    value: function getValues() {
      if (!this.isEnabled()) {
        return null;
      }
      var pluginConfig = this.getPlugin().getConfig();
      var json = {
        configuration: {}
      };
      json.configuration[this.bundleName] = {
        conf: pluginConfig,
        state: {}
      };
      return json;
    }
  }, {
    key: "isDisplayed",
    value: function isDisplayed() {
      // Check if selected layers include wfs layers
      return this.getSandbox().findAllSelectedMapLayers().some(function (l) {
        return l.hasFeatureData();
      });
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.FeaturedataTool', FeaturedataTool, {
  protocol: ['Oskari.mapframework.publisher.Tool']
});
export { FeaturedataTool };